module.exports = __webpack_public_path__ + "static/media/Happy.c86dfbaf.png";